<mat-card appearance="outlined" class="mb-3">
  <mat-card-header>
    <mat-card-title>
      <h2 i18n>Configuration</h2>
    </mat-card-title>
    <mat-card-subtitle>
      <p class="subtitle-help-text" i18n>
      Please configure the settings for the item here. If you are providing multiple options within this item you can use this configuration as a template for the options below.
      </p>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <mat-card appearance="outlined" style="position: relative; margin-bottom: 8px">
      <mat-card-header>
        <mat-card-title>
          <h3>
            {{ item.name }}
            @if (item.userCanBook()) {
              <app-badge [variant]="getBookableBadgeVariant()" [title]="getBookableBadgeTitle()"></app-badge>
            }
          </h3>
        </mat-card-title>
        @if (!item.showSettings) {
          <mat-card-subtitle>
            <eas-editor-booking-item-option-summary class="subtitle-text" [itemOption]="item"></eas-editor-booking-item-option-summary>
          </mat-card-subtitle>
        }
        <div class="mat-mdc-card-header-actions">
          <ul class="nav justify-content-end">
            <li class="nav-item">
              <button mat-icon-button
                [attr.aria-label]="getSettingsButtonTitle()"
                (click)="onToggleShowSettings()">
                <mat-icon>
                  {{ item.showSettings ? 'expand_less' : 'expand_more' }}
                </mat-icon>
              </button>
            </li>
            <li class="nav-item">
              <button mat-icon-button
                aria-label="Edit option"
                i18n-aria-label
                (click)="onEdit()">
                <mat-icon>edit</mat-icon>
              </button>
            </li>
            <li class="nav-item">
              <button mat-icon-button [matMenuTriggerFor]="itemOptionDropdown" aria-label="Show more option actions" i18n-aria-label>
                <mat-icon>more_horiz</mat-icon>
              </button>
              <mat-menu #itemOptionDropdown="matMenu">
                <button mat-menu-item (click)="onAddChild()" i18n>Add suboption</button>
                <button mat-menu-item (click)="onEditNameList()" i18n>Edit titles</button>
              </mat-menu>
            </li>
          </ul>
        </div>
      </mat-card-header>
      @if (item.showSettings) {
        <mat-card-content>
          <table class="table table-md">
            <colgroup>
            <col style="width: 30%"><col><col>
          </colgroup>
          <tbody eas-editor-booking-item-tree-booking-type></tbody>
          <tbody eas-editor-booking-item-tree-exam-type></tbody>
          <tbody eas-editor-booking-item-booking [item]="item"></tbody>
          @for (itemSetting of item.settings; track itemSetting; let itemSettingIndex = $index) {
            <tbody eas-editor-booking-item-setting
              [item]="item" [itemSetting]="itemSetting" [itemSettingIndex]="itemSettingIndex">
            </tbody>
          }
          <tbody eas-editor-booking-item-tree-extra-roles></tbody>
          <tbody eas-editor-booking-item-metadata-list [item]="item"></tbody>
        </table>
      </mat-card-content>
    }
  </mat-card>
  <eas-editor-booking-item-option-list [itemOptions]="itemOptions"></eas-editor-booking-item-option-list>
  <div style="margin-left: 15px; margin-bottom: 8px; padding-left: 15px; padding-bottom: 8px; border-left: 2px dashed gray;" i18n>
      Add options if you wish to create multiple options within this bookable item. Options can be created as a hierarchy and each will inherit settings from above unless overridden.
    </div>
  <button mat-flat-button color="primary" (click)="onAddItem()" style="margin-left: 15px" i18n>Add option</button>
</mat-card-content>
<ul class="nav justify-content-end">
  <li class="nav-item">
    <button mat-icon-button
      aria-label="Export"
      i18n-aria-label
      (click)="onExport()">
      <mat-icon>file_download</mat-icon>
    </button>
  </li>
</ul>
</mat-card>
